import { Project } from '@mb/lib';
import { createSlice } from '@reduxjs/toolkit';

interface InitialStateType {
  projectsList: Project[];
  isProjectModalOpen: boolean;
  isProjectsLoaded: boolean;
  projectModalEventLocation: string;
}

export const initialState: InitialStateType = {
  projectsList: [],
  isProjectModalOpen: false,
  isProjectsLoaded: false,
  projectModalEventLocation: '',
};

const projectsSlice = createSlice({
  name: 'projectsSlice',
  initialState,
  reducers: {
    setIsProjectModalOpen(state, { payload }) {
      state.isProjectModalOpen = payload;
    },
    setProjectModalEventLocation(state, { payload }) {
      state.projectModalEventLocation = payload;
    },
  },
});

export const { setIsProjectModalOpen, setProjectModalEventLocation } =
  projectsSlice.actions;
export default projectsSlice.reducer;
